import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFohSupportServer = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	fill: "none",
	viewBox: "0 0 64 64",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#9236C8",
			d: "M29.09 1.085a4.445 4.445 0 0 1 5.82 0L37.127 3a4.45 4.45 0 0 0 3.912.97l2.848-.66a4.46 4.46 0 0 1 5.154 2.722l1.078 2.734a4.48 4.48 0 0 0 3.016 2.689l2.827.747a4.49 4.49 0 0 1 3.306 4.82l-.308 2.925a4.51 4.51 0 0 0 1.429 3.791l2.157 1.984a4.515 4.515 0 0 1 .702 5.814l-1.623 2.446a4.52 4.52 0 0 0-.486 4.025l.994 2.766a4.51 4.51 0 0 1-2.063 5.476l-2.567 1.407a4.5 4.5 0 0 0-2.289 3.336l-.397 2.914c-.3 2.2-2.15 3.85-4.356 3.884l-2.922.045a4.46 4.46 0 0 0-3.568 1.884l-1.697 2.395a4.45 4.45 0 0 1-5.65 1.401l-2.61-1.326a4.44 4.44 0 0 0-4.029 0l-2.608 1.326a4.45 4.45 0 0 1-5.65-1.401l-1.698-2.395a4.46 4.46 0 0 0-3.567-1.884l-2.923-.045a4.476 4.476 0 0 1-4.356-3.884l-.397-2.914a4.5 4.5 0 0 0-2.289-3.337L3.93 46.25a4.51 4.51 0 0 1-2.063-5.476l.994-2.766a4.52 4.52 0 0 0-.486-4.025L.752 31.537a4.515 4.515 0 0 1 .702-5.814L3.61 23.74a4.51 4.51 0 0 0 1.429-3.79l-.308-2.926a4.49 4.49 0 0 1 3.306-4.82l2.827-.747a4.48 4.48 0 0 0 3.016-2.689l1.078-2.734a4.46 4.46 0 0 1 5.154-2.721l2.848.66a4.45 4.45 0 0 0 3.912-.97z"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 32,
			cy: 32,
			r: 24,
			fill: "#BE64F3"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 32,
			cy: 32,
			r: 20,
			fill: "#7A13B6"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#DBA0FD",
			fillRule: "evenodd",
			d: "M32.603 21.97a.97.97 0 1 0-1.94 0v1.982a9.7 9.7 0 0 0-7.835 5.592.97.97 0 1 0 1.76.81 7.76 7.76 0 0 1 6.956-4.51 1 1 0 0 0 .178 0 7.754 7.754 0 0 1 7.607 6.79h-4.787a.97.97 0 1 0 0 1.938h7.756a.97.97 0 1 0 0-1.939H41.28a9.694 9.694 0 0 0-8.677-8.68zm-11.634 9.694a.97.97 0 0 0-.969.97v6.785a.97.97 0 0 0 .536.868l6.608 3.303a3.88 3.88 0 0 0 3.126.152l11.406-4.387a.97.97 0 0 0 .617-.993l-.965.088c.965-.088.965-.089.965-.09v-.004l-.001-.006-.002-.016-.002-.018-.003-.02-.018-.112a3.1 3.1 0 0 0-.61-1.307c-.59-.742-1.611-1.335-3.238-1.335h-4.847a4.85 4.85 0 0 0-3.878-1.939h-2.45c-.718-.766-1.718-1.221-2.588-1.493-1.042-.326-2.086-.446-2.717-.446zm17.45 5.817c.874 0 1.328.234 1.57.445l-10.415 4.006a1.94 1.94 0 0 1-1.563-.076l-6.072-3.036v-5.217c.44 0 1.29.092 2.138.357.874.273 1.569.674 1.915 1.168a.97.97 0 0 0 .794.414h2.908a2.91 2.91 0 0 1 2.742 1.939h-5.65a.97.97 0 1 0 0 1.938h6.786a.97.97 0 0 0 .97-.969q-.001-.493-.098-.97z",
			clipRule: "evenodd"
		})
	]
});
const ForwardRef = forwardRef(SvgFohSupportServer);
export default ForwardRef;
